import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-526c53ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "plan-feature-locked__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-lock-key" })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "plan-feature-locked__eyebrow" }, "Recurso do plano", -1))
const _hoisted_3 = { class: "plan-feature-locked__title" }
const _hoisted_4 = { class: "plan-feature-locked__message" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow ms-5 fs-12" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["plan-feature-locked", { 'plan-feature-locked--overlay': _ctx.overlay }])
  }, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.title), 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.message), 1),
    _createElementVNode("button", {
      type: "button",
      class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 rounded-1 bg-success fs-md-15 fs-lg-16",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToPayment && _ctx.goToPayment(...args)))
    }, [
      _createTextVNode(" Trocar plano "),
      _hoisted_5
    ])
  ], 2))
}